export const es = {
  languageCode: 'es',
  nativeName: 'Español',
  hello: 'Hola',
  welcome: 'Bienvenido',
  enterName: 'Nombre',
  rooms: 'Salas',
  findPerfectRoom:
    'Encuentra la sala perfecta para practicar tus habilidades lingüísticas',
  createRoom: 'Crear Sala',
  filterRooms: 'Filtrar Salas',
  activeFilters: 'Filtros activos',
  searchIn: 'Buscar en',
  whyItWorks: 'Por qué funciona',
  howItWorks: 'Cómo funciona',
  targetGroup: 'Grupo objetivo',
  earlyAccess: 'Acceso anticipado',
  speakLearnConnect: 'Habla. Aprende. Conecta.',
  whyLanguageRoomsWorks: 'Por qué Language Rooms funciona',
  theLanguageRoomsMethod: 'El método Language Rooms',
  howLanguageRoomsWorks: 'Cómo funciona Language Rooms',
  becomeALanguageRoomsPioneer: 'Conviértete en pionero de Language Rooms',
  yourVoiceMatters: 'Tu opinión importa',
  perfectForIntermediateLearnersAndBeyond:
    'Perfecto para estudiantes intermedios y más allá',
  whoBenefitsMost: 'Quién se beneficia más',
  ourExcitingRoadmap: 'Nuestra emocionante hoja de ruta',
  whyYourFeedBackIsCrucial: '¿Qué podemos mejorar?',
  howToProvideFeedback: 'Cómo proporcionar retroalimentación',
  speakEarlySpeakOften: 'Habla temprano, habla a menudo',
  learnFromNativeSpeakers: 'Aprende de hablantes nativos',
  embraceTheFun: 'Disfruta aprendiendo',
  progressingLearners: 'Estudiantes en progreso',
  rustySpeakers: 'Hablantes oxidados',
  skillMaintainers: 'Mantenedores de habilidades',
  culturalEnthusiasts: 'Entusiastas culturales',
  joinARoom: 'Únete a una sala',
  startSpeaking: 'Empieza a hablar',
  levelUpYourLingo: 'Mejora tu idioma',
  phaseOneLaunch: 'Fase 1: Lanzamiento',
  phaseTwoCommunityGrowth: 'Fase 2: Crecimiento de la comunidad',
  phaseThreeGlobalScale: 'Fase 3: Escala global',
  traditionalMethod: 'Método tradicional',
  languageRoomsMethod: 'Método Language Rooms',
  join: 'Unirse',
  create: 'Crear',
  save: 'Guardar',
  cancel: 'Cancelar',
  leave: 'Salir',
  checkAudioDevices: 'Verificar dispositivos de audio',
  mute: 'Silenciar',
  unmute: 'Activar sonido',
  back: 'Atrás',
  joinTheWaitlist: 'Unirse a la lista de espera',
  exploreRooms: 'Explorar salas',
  requestEarlyAccess: 'Solicitar acceso anticipado',
  earlyAccessRequested: 'Acceso anticipado solicitado',
  searchRooms: 'Buscar por título o descripción...',
  allLanguages: 'Todos los idiomas',
  allLevels: 'Todos los niveles',
  search: 'Buscar',
  title: 'Título',
  description: 'Descripción',
  difficulty: 'Dificultad',
  tags: 'Etiquetas',
  maxTags: 'máximo {0}',
  charactersMax: 'máximo {0} caracteres',
  maximal: 'máximo',
  titlePlaceholder: 'Ingresa un título descriptivo para tu sala',
  descriptionPlaceholder:
    'Describe lo que los participantes pueden esperar en tu sala',
  allRightsReservedFunny:
    '¡Todos los derechos reservados. ¡Ahora ve y practica tus erres!',
  connectWithNativeSpeakersEngage:
    'Conéctate con hablantes nativos, participa en conversaciones reales y aprende hablando.',
  ourPlatformFocusesOnSpeaking:
    'Nuestra plataforma se centra en hablar primero, haciendo que el aprendizaje de idiomas sea divertido y efectivo.',
  weHaveThreeCorePrinciples:
    'Tenemos tres principios fundamentales como base de Language Rooms. Están probados y comprobados para proporcionar un aprendizaje rápido y efectivo.',
  languageRoomsIsDesignedTo:
    'Language Rooms está diseñado para llevar tus habilidades al siguiente nivel. Ya sea que quieras mejorar, mantener o recuperar tus habilidades lingüísticas, nuestra plataforma ofrece el entorno perfecto.',
  wereGraduatelyOpeningOurDoors:
    '¡Bienvenido a Language Rooms! Únete a nuestros miembros fundadores y comienza a hablar ahora.',
  welcomeMessage: '¡Bienvenido a Language Rooms!',
  founderBadgeTitle: 'Miembro Fundador',
  welcomeToLanguageRooms: '¡Bienvenido a Language Rooms!',
  welcomeSubtitle: 'La forma más rápida de hablar idiomas con confianza',
  welcomeDescription:
    '¡Eres uno de nuestros primeros visitantes! Únete a nosotros para crear la plataforma más efectiva para practicar idiomas hablando.',
  joinPioneerCommunity: 'Únete a Nuestra Comunidad Pionera',
  pioneerCommunityDescription:
    'Sé de los primeros en practicar idiomas a través de conversaciones reales',
  earlyAccessBenefits: 'Beneficios de Acceso Anticipado',
  earlyAccessBenefitsDescription:
    'Obtén funciones exclusivas y soporte prioritario como miembro fundador',
  helpUsGrow: 'Ayuda a Dar Forma al Futuro',
  helpUsGrowDescription:
    'Tu opinión ayudará a crear la mejor plataforma de práctica oral',
  whySpeakingMatters: 'Por Qué Hablar es Importante',
  whySpeakingMattersDescription:
    '¡Hablar es la forma más rápida de dominar un idioma. No más estudio silencioso - empieza a hablar ahora!',
  getStartedButton: 'Empezar a Hablar',
  weValueYourInput: 'Valoramos tu opinión',
  lookForTheFeedbackButton:
    'Busca el botón "Dar retroalimentación" en la parte inferior derecha de cada página. Tus comentarios nos ayudan a crear la mejor experiencia de aprendizaje de idiomas posible.',
  sevenYears: '7 Años',
  threeMonths: '3 Meses',
  yearsOfTextBooksAndGrammar:
    'Años de libros de texto y ejercicios de gramática llevaron a conjugaciones perfectas pero pánico en conversaciones reales.',
  immersiveLearningAndRealConversations:
    'El aprendizaje inmersivo y las conversaciones reales llevaron a habilidades confiadas en español en solo tres meses.',
  noMoreYearsOfSilentStudy:
    'No más años de estudio silencioso. Comienza a hablar inmediatamente, aunque solo sea "Hello" repetidamente. Así es como comencé mi viaje con el inglés.',
  textBooksCantTeachYou:
    'Los libros de texto no pueden enseñarte cómo hablan realmente los locales. Nuestra plataforma te conecta con hablantes nativos para un uso auténtico y práctico del idioma.',
  learningALanguageShouldBeFun:
    'Aprender un idioma debería ser divertido, no una tarea. Hemos infundido diversión en cada aspecto de Language Rooms, porque sabemos de primera mano que funciona.',
  extensiveGrammarFocus: 'Enfoque extensivo en gramática',
  vocabularyMemorization: 'Memorización de vocabulario',
  limitedPracticalApplication: 'Aplicación práctica limitada',
  focusOnPracticalUsage: 'Enfoque en el uso práctico',
  dailyConversationPractice: 'Práctica de conversación diaria',
  highConfidenceInRealSituations: 'Alta confianza en situaciones reales',
  shapeTheFutureOfLanguageRooms: 'Da forma al futuro de Language Rooms',
  suggestNewFeaturesAndImprovements: 'Sugiere nuevas funciones o mejoras',
  reportAnyIssues: 'Informa cualquier problema que encuentres',
  shareYourSuccessStories: 'Comparte tus historias de éxito',
  error: 'Error',
  startAConversation: 'Inicia una conversación',
  chatWithOtherParticipants:
    '¡Chatea con otros participantes en esta sala. Comparte ideas, haz preguntas o simplemente saluda!',
  anonymous: 'Anónimo',
  localStreamNotFound:
    'Se requiere acceso al micrófono para el chat de voz. Por favor, haz clic en el ícono del micrófono en tu navegador y permite el acceso para continuar hablando con otros.',
  typeMessage: 'Escribe un mensaje...',
  showChat: 'Mostrar chat',
  hideChat: 'Ocultar chat',
  language: 'Idioma',
  English: 'Inglés',
  Spanish: 'Español',
  German: 'Alemán',
  French: 'Francés',
  Italian: 'Italiano',
  Japanese: 'Japonés',
  Chinese: 'Chino',
  Korean: 'Coreano',
  Beginner: 'Principiante',
  Intermediate: 'Intermedio',
  Advanced: 'Avanzado',
  DailyLife: 'Vida Diaria',
  FoodAndDrink: 'Comida y Bebida',
  Travel: 'Viajes',
  Culture: 'Cultura',
  Business: 'Negocios',
  Technology: 'Tecnología',
  Entertainment: 'Entretenimiento',
  Sports: 'Deportes',
  Education: 'Educación',
  Arts: 'Arte',
  Music: 'Música',
  Literature: 'Literatura',
  CurrentEvents: 'Eventos Actuales',
  Science: 'Ciencia',
  HealthAndWellness: 'Salud y Bienestar',
  Hobbies: 'Pasatiempos',
  noRoomsFound: 'No se encontraron salas',
  itLooksLikeThereAreNoRooms: `Parece que no hay salas disponibles en este momento. ¡Puedes intentar ajustar tus filtros o crear una nueva sala para comenzar una conversación!`,
  participant: 'participante',
  participants: 'Participantes',
  enableVoiceChat: 'Activar chat de voz',
  tryAgain: 'Intentar de nuevo',
  loading: 'Cargando...',
  edit: 'Editar',
  stayAnonymous: 'Mantener anónimo',
  joinAnonymously: 'Unirse anónimamente',
  featuredRooms: 'Salas Destacadas',
  joinOneOfOurPopularRooms:
    'Únete a una de nuestras salas populares y comienza a practicar con hablantes nativos de inmediato.',
  readyToStartSpeaking: '¿Listo para Empezar a Hablar?',
  joinARoomAndStartPracticing:
    '¡Únete a una sala ahora y comienza a practicar con hablantes nativos. La mejor manera de aprender es practicando!',
  findARoomNow: 'Encuentra una Sala Ahora',
  foundingMember: 'Miembro fundador',
  pioneerBadge: 'Pionero',
  betaTester: 'Beta tester',
  thankYouForYourFeedback: '¡Gracias por tus comentarios!',
  giveFeedback: 'Dar feedback',
  sendFeedback: 'Enviar feedback',
  shareFeedbackSubtitle:
    'Comparte tus pensamientos, ideas, problemas o simplemente saluda 👋🏻',
  somethingWentWrong: 'Algo salió mal',
  unexpectedError: 'Ocurrió un error inesperado',
  errorPageMessage:
    '¡Nos disculpamos por la inconveniencia. Por favor, inténtalo de nuevo o regresa a la página anterior.',
  useFeedbackTool:
    '¿Tienes problemas? ¡Por favor, no dudes en darnos feedback.',
  pageNotFound: 'Página no encontrada',
  pageNotFoundMessage:
    'La página que estás buscando no existe o ha sido movida.',
  backToHome: 'Volver a la página de inicio',
  justNow: 'ahora',
  minuteAgo: 'hace 1 minuto',
  minutesAgo: 'hace {0} minutos',
  hourAgo: 'hace 1 hora',
  hoursAgo: 'hace {0} horas',
  dayAgo: 'hace 1 día',
  daysAgo: 'hace {0} días',
  weekAgo: 'hace 1 semana',
  weeksAgo: 'hace {0} semanas',
  monthAgo: 'hace 1 mes',
  monthsAgo: 'hace {0} meses',
  yearAgo: 'hace 1 año',
  yearsAgo: 'hace {0} años',
  letsSpeak: '¡Vamos a hablar!',
  letsSpeakMessage:
    'Recuerda, cometer errores es parte del aprendizaje. Cuanto más hablas, más confiado te sentirás!',
  roomInfo: 'Información de la Sala',
  share: 'Compartir',
  shareRoom: 'Compartir Sala',
  suggestedQuestions: 'Preguntas sugeridas',
  conversationStarters: 'Inicios de conversación',
  vocabulary: 'Vocabulario',
  relatedToTags: 'Relacionado a Etiquetas',
  other: 'Otro',
  questions: 'preguntas',
  general: 'General',
  more: 'Más',
  needSomethingElse: '¿Necesitas algo más?',
  speakingMaterialFeedbackPrompt:
    'Si necesitas algo más para ayudarte mientras hablas, por favor háznoslo saber y lo consideraremos para el material de habla.',
  additionalFeedback:
    'También si tienes algún comentario adicional sobre el material, nos encantaría saberlo.',
  enterYourName: '¿Cuál es tu nombre?',
  learnLanguages: 'Aprende Idiomas',
  through: '',
  speaking: 'Hablando',
  whichLanguageDoYouWantToSpeak: '¿Qué idioma quieres hablar?',
  joinSpeakersFromOver: 'Habla con personas de más de 20+ países',
  exploreMoreLanguages: 'Explora más idiomas',
  online: 'en línea',
  languagesAvailable: 'Idiomas disponibles',
  practiceAnytime: 'Practica en cualquier momento',
  why: 'Por que',
  worksBetter: 'funciona mejor',
  traditionalLearning: 'Aprendizaje tradicional',
  yearsOfFrenchInSchool: 'Años de francés en la escuela',
  countlessHoursMemorizingVerbConjugations:
    'Innumerables horas memorizando conjugaciones verbales',
  perfectTestScoresButNeverSpokeInClass:
    'Puntuaciones perfectas en exámenes, pero nunca hablado en clase',
  resultCantHoldBasicConversationToday:
    'Resultado: No puede mantener una conversación básica hoy',
  monthsOfSpanishPractice: 'Meses de práctica de español',
  dailyConversationsWithNativeSpeakers:
    'Conversaciones diarias con hablantes nativos',
  learningThroughRealWorldDiscussions:
    'Aprendiendo a través de discusiones del mundo real',
  resultConfidentlySpeakingWithNatives:
    'Resultado: Manteniendo conversaciones con confianza',
  immediatePractice: 'Práctica inmediata',
  nativeSpeakers: 'Hablantes nativos',
  realResults: 'Resultados reales',
  startSpeakingFromDayOneNoMoreSilentStudying:
    'Empieza a hablar desde el día uno, no más estudio silencioso',
  learnHowLocalsReallyTalkNotJustTextbookPhrases:
    'Aprende cómo hablan realmente los locales, no solo frases de libro de texto',
  buildGenuineConfidenceThroughActualConversations:
    'Construye confianza genuina a través de conversaciones reales',
  realStoriesRealProgress: 'Historias reales, Progreso real',
  joinThousandsOfLanguageLearners:
    'Únete a miles de estudiantes de idiomas que han encontrado su confianza al hablar a través de Language Rooms',
  afterReturningFromSpainIStruggled:
    'Después de volver de España, me costaba mantener mi español. Language Rooms me da la oportunidad diaria de hablar con nativos y mejorar mis habilidades.',
  iCompletedAllOfDuolingo:
    'Completé muchas lecciones de idiomas pero no podía hablar con confianza. ¡Aquí practico conversaciones reales y mi ansiedad al hablar ha desaparecido!',
  asABusyProfessionalINeededFlexiblePracticeTimes:
    'Como profesional ocupada, necesitaba horarios de práctica flexibles. La disponibilidad 24/7 de hablantes nativos aquí es exactamente lo que buscaba.',
  returnedExchangeStudent: 'Ex estudiante de intercambio',
  languageEnthusiast: 'Entusiasta de idiomas',
  businessProfessional: 'Profesional de negocios',
  joinLearnersFromOver: 'Únete a estudiantes de más de',
  whoAreAlreadyImprovingTheirLanguageSkills:
    'que ya están mejorando sus habilidades lingüísticas a través de conversaciones reales',
  countries: 'países',
  findThePerfectRoomForYou: 'Encuentra la sala perfecta para ti',
  email: 'Correo electrónico',
  muted: 'Micrófono silenciado',
  unmuted: 'Micrófono activado',
  availableSlots: 'Plaza disponible',
  typeAMessage: 'Escribe un mensaje...',
  you: 'Tú',
  noMessagesYetStartTheConversation:
    'Aún no hay mensajes. ¡Comienza la conversación!',
  microphoneAccessRequired: 'Acceso al micrófono requerido',
  microphoneAccessRequiredDescription:
    'Para usar esta plataforma, necesitas permitir el acceso al micrófono. Por favor, habilita el acceso en las configuraciones de tu navegador y actualiza la página.',
  faster: 'Más rápido',
  thanTraditionalLearning: 'que el aprendizaje tradicional',
  realWorldSkills: 'Habilidades del mundo real',
  naturalLanguagePatternsAndExpressions:
    'Patrones y expresiones de lenguaje natural',
  buildConfidenceThroughRegularPractice:
    'Construir confianza a través de la práctica regular',
  strongFoundation: 'Base fuerte',
  structuredGrammarAndVocabularyLearning:
    'Aprendizaje estructurado de gramática y vocabulario',
  systematicProgressionThroughLanguageLevels:
    'Progresión sistemática a través de niveles de idioma',
  professionalGuidanceAndFeedback: 'Guía profesional y retroalimentación',
  realWorldSkillsDescription: 'Conversaciones reales con hablantes nativos',
  improve: 'Mejora',
  yourLanguageSkills: 'tu dominio del idioma',
  combineStructuredLearningWithRealWorldSpeakingPractice:
    'Combina aprendizaje estructurado con práctica de habla en el mundo real',
  serverIssues: 'Problemas de conexión del servidor',
  serverIssuesDescription:
    'Estamos experimentando algunos problemas técnicos con nuestros servidores de chat de voz. La funcionalidad de chat de voz podría estar temporalmente limitada. Nuestro equipo está trabajando para resolver este problema. Disculpen cualquier inconveniente.',
  connecting: 'Conectando',
  roomIsFull: 'Esta sala está llena',
  joinAnotherRoom: 'Unirse a otra sala',
  audioSettings: 'Configuración de audio',
  microphone: 'Micrófono',
  speaker: 'Altavoz',
  audioDevices: 'Dispositivos de audio',
  audioDevicesDescription:
    'Selecciona los dispositivos de audio que quieres usar para el chat de voz.',
  browseOtherRooms: 'Explorar otras salas',
  roomIsFullDescription:
    'Esta sala está actualmente llena. Puedes esperar a que alguien se vaya o intentar otra sala.',
  readyToJoin: '¿Listo para unirte{0}?',
  didntFindARoomThatFitsYou: 'No encontraste una sala que te guste?',
  createYourOwnRoomAndStartAConversation:
    'Crea tu propia sala y comienza una conversación en tus términos.',
  createARoom: 'Crear una Sala',
  metaDefaultTitle: 'Habla. Aprende. Conecta. Language Rooms.',
  metaDefaultDescription:
    'Conéctate con hablantes nativos, participa en conversaciones reales y aprende a través del habla. Language Rooms se centra en el habla como primer paso, haciendo que el aprendizaje del idioma sea divertido y efectivo. Únete a nosotros y habla tu camino hacia la fluidez!',
  metaDefaultKeywords:
    'idioma, hablar, aprender, conectar, practicar, hablar idioma, aprender idioma, Language Rooms, fluidez, chat de voz, voz, inglés, español, alemán',
  metaDefaultCanonical: 'https://language-rooms.com/es',
} as const;
